export const GAME_PHASES = Object.freeze({
    INIT: "INIT",
    PLAYER_TURN: "PLAYER_TURN",
    RESOLUTION: "RESOLUTION",
    GAME_OVER: "GAME_OVER",
});